//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popup'
import 'devextreme/ui/popover'
import 'devextreme/ui/progress_bar'

//#endregion

import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import {
    DATE_BOX_CONTROLS_SERVICE_NAME,
    VALIDATION_CONTROLS_SERVICE_NAME,
    DateBoxControlsService,
    ValidationControlsService
} from '../../../services/controls'

import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'

import { GridEditController } from './grid-edit.controller'

//#region Asset Imports

import './grid-edit.scss'
import * as TEMPLATE from './grid-edit.tpl.html'

//#endregion

export class GridEditDirective implements ng.IDirective {
    restrict = 'E'

    scope = {
        source: '='
    }

    template = TEMPLATE

    link = (scope, element, attrs) => {
        scope.$watch("source", value => {
            scope.source = value
        })
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        '$compile',
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'api',
        'logger',
        'localDictionary',
        DATE_BOX_CONTROLS_SERVICE_NAME,
        VALIDATION_CONTROLS_SERVICE_NAME,
        (
            $scope,
            $compile: ng.ICompileService,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            api: Api,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            dateBoxControlsService: DateBoxControlsService,
            validationControlsService: ValidationControlsService
        ) => {
            return new GridEditController($scope, $compile, $q, $timeout, api, logger, localDictionary, dateBoxControlsService, validationControlsService)
        }]
}